import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const MasspUseCaseValidatorUiOptionsSchema = z.object({
  isEditMode: z
    .boolean()
    .optional()
    .describe('Whether the field is in edit mode'),
});

// Transforms the Zod schema to a TypeScript type
export type MasspUseCaseValidatorUiOptions = z.infer<
  typeof MasspUseCaseValidatorUiOptionsSchema
>;

/* The field schema for the MasspUseCaseValidator field extension */
export const MasspUseCaseValidatorFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('MASSP4AI Use Case ID Validator'),
  MasspUseCaseValidatorUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type MasspUseCaseValidatorProps =
  typeof MasspUseCaseValidatorFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const MasspUseCaseValidatorSchemaFinal =
  MasspUseCaseValidatorFieldSchema.schema;

// Legacy export for backward compatibility (if needed)
export const MasspUseCaseValidatorSchema =
  MasspUseCaseValidatorFieldSchema.schema;
